import { Injectable } from "@angular/core";
import {
  HttpClient,
  HttpHeaders,
  HttpErrorResponse,
  HttpParams,
} from "@angular/common/http";
import { Observable, throwError, of } from "rxjs";
import { map, catchError } from "rxjs/operators";
import { SessionExpiredService } from "./session-expired-service";
import { IApiResponse } from "../core/models/api-response.model";
import { AppConfig } from "../design/app";
import { IAppConfig } from "../core/models/app-config.model";
import { SubscriptionSearchDataObject } from "../models/subscription-search-data-object";

@Injectable({
  providedIn: "root",
})
export class SubscriptionSearch {
  private appConfig: any;
  Urls: Array<string> = [];

  constructor(private http: HttpClient, private _sessionExpiredService: SessionExpiredService) {
    this.appConfig = AppConfig;
    const urlsStartPoint = this.appConfig.session.baseUrl;

    this.Urls = [
      urlsStartPoint + `${this.appConfig.session.getCompanies}?searchword={term}&count={count}`,
      urlsStartPoint + `${this.appConfig.session.getPPMDs}?count={count}&searchText={term}`,
      urlsStartPoint + `${this.appConfig.session.getAllCoordinators}?count={count}&searchText={term}`,
    ]
  }

  getSubscriptionSearchData(inputData: any): Observable<SubscriptionSearchDataObject> {
    const baseUrl = this.appConfig.subscription.baseUrl;
    const getSubscriptionSearchResults = this.appConfig.subscription.getSubscriptionSearchResults;
    const url = `${baseUrl + getSubscriptionSearchResults}`;

    return this.http.post<IApiResponse<SubscriptionSearchDataObject>>(url, inputData).pipe(
      map((res) => {
        return res.Data;
      }),
      catchError(this.handleError)
    );
  }

  public searchword(term: string, target: number) {
    if (term === "" || term.length <= 2) {
      return of([]);
    }
    const headers = new HttpHeaders();
    const count = this.appConfig.searchCount ? this.appConfig.searchCount : "15";
    const countryURL = this.Urls[target].replace("{term}", term).replace("{count}", count);

    if (target === 0) {
      const baseUrl = this.appConfig.session.baseUrl;
      const getCompanies = this.appConfig.session.getCompanies;
      const apiUrl = `${baseUrl + getCompanies}`;
      
      const request = {
        companyname: term,
        count: count
      }
      return this.http.post<IApiResponse<any>>(apiUrl, request, { headers: headers }).pipe(
        map((res) => res.Data),
        catchError(this.handleError)
      );
    } else {
      return this.http
        .get(countryURL, { headers: headers })
        .pipe(
          map((response) =>
            target === 1 ? JSON.parse(response.toString()) : response
          )
        );
    }
  }

  public exportReport(subscriptionUniqueIds: string[]) {
    const baseUrl = this.appConfig.subscription.baseUrl;
    const exportSubscriptionData = this.appConfig.subscription.exportSubscriptionData;
    const url = `${baseUrl + exportSubscriptionData}`;
    return this.http.post(url, subscriptionUniqueIds, { responseType: 'blob' });
    //return new Observable((obs) => {
    //  var request = new XMLHttpRequest();
    //  request.open("POST", url, true);
    //  request.setRequestHeader("content-type", "application/json");
    //  request.responseType = "arraybuffer";
    //  request.onload = function (oEvent) {
    //    var arrayBuffer = request.response;
    //    var byteArray = new Uint8Array(arrayBuffer);
    //    obs.next(byteArray);
    //  };

    //  const body = JSON.stringify(subscriptionUniqueIds);
    //  request.send(body);
    //  this._sessionExpiredService.resetTimer();
    //});
  }

  private handleError(error: HttpErrorResponse) {
    if (error.error instanceof ErrorEvent) {
      console.error("An error occurred:", error.error.message);
    } else {
      console.error(
        `Backend returned code ${error.status}, ` + `body was: ${error.error}`
      );
    }
    return throwError("Something bad happened; please try again later.");
  }
}
